import { render, staticRenderFns } from "./HeaderPane.vue?vue&type=template&id=4e15be42&scoped=true"
import script from "./HeaderPane.vue?vue&type=script&lang=ts"
export * from "./HeaderPane.vue?vue&type=script&lang=ts"
import style0 from "./HeaderPane.vue?vue&type=style&index=0&id=4e15be42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e15be42",
  null
  
)

export default component.exports